export const SOL_BOOT_SPLASH_DIAMOND_SRC = '/images/pwa/img_diamond.png';
export const SOL_BOOT_SPLASH_LOCKUP_SRC = '/images/pwa/img_sukanda_white.png';
export const SOL_BOOT_SPLASH_TAGLINE_SRC = '/images/pwa/img_delivering_joy.png';
